<template>
    <header>
        <div class="container-fluid">
            <div class="row">
                <div class="col-5 col-lg-2">
                    <logo></logo>
                </div>
                <div class="col-2 offset-3 offset-lg-0 col-lg-9">
                    <div class="d-flex">
                        <preferences ref="preferences"></preferences>
                        <span class="d-none d-lg-block">
                            <account-info></account-info>
                        </span>
                    </div>
                </div>
                <div class="col-2 col-lg-1">
                    <navigation ref="navigation"></navigation>
                </div>
            </div>
        </div>

    </header>
</template>


<script>
    import Logo from '../components/Logo.vue'
    import Preferences from './PreferencesNav.vue'
    import AccountInfo from '../components/AccountInfo.vue'
    import Navigation from './Navigation.vue'

    export default {
        name: 'main-header',
        components: {
            Logo,
            Preferences,
            AccountInfo,
            Navigation
        },

        methods: {
            checkOpenNav:function () {
                this.$refs.navigation.toggleOpen()
            },
            checkOpenPref:function () {
                this.$refs.preferences.toggleOpen()
            }
        }
    }
</script>
